module.exports = __webpack_public_path__ + "static/media/plus.f53316dd.svg";